import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  height: calc(100vh - 60px);
  width: 100vw;
  overflow-y: hidden;
`
